export default __webpack_public_path__ + "static/media/eurdf.e40d2c5a.png";